import { isNil } from 'lodash';
import React, { useCallback, useContext, useMemo } from 'react';
import { CardFormContext } from '@shared/components/blocks/contexts/form';
import { UrlField } from '@shared/data/entity/fields/UrlField';
import { UrlEditField } from '@shared/scenes/entity/components/fields/UrlEditField';
import { isFieldModified } from '@shared/scenes/entity/util/isFieldRecordModified';
import { UrlComponent } from '../../config';
import { WorkflowComponentProps } from './WorkflowComponent';

export function WorkflowUrlComponentLowCode(props: WorkflowComponentProps) {
  const { setFieldError, errors } = useContext(CardFormContext);

  return <WorkflowUrlComponent {...props} setFieldError={setFieldError} errors={errors} />;
}

export function WorkflowUrlComponent(
  props: WorkflowComponentProps & {
    setFieldError: (id: string, error: string) => void;
    errors: { [key: string]: string };
  },
) {
  const { onDataChanged } = props;

  const field = useMemo(() => {
    return isNil(props.initialData) ? null : new UrlField(props.initialData);
  }, [props.initialData]);

  const updateField = useCallback(
    (componentId: string, newField: UrlField | null) => {
      if (!isFieldModified(field, newField)) {
        return;
      }
      if (isNil(newField)) {
        onDataChanged?.(componentId, null);
      } else {
        onDataChanged?.(componentId, newField.toFieldJson());
      }
    },
    [onDataChanged, field],
  );

  return (
    <UrlEditField
      field={field}
      {...props}
      component={props.component as UrlComponent}
      updateField={updateField}
      error={props.errors[props.component.id]}
    />
  );
}
